export const navList = [{
    label: "B2B出口",
    path: "/btoB",
    disabled: true,
}, {
    label: "9710 9810出口业务介绍",
    path: "/btoB/sales"
}, {
    label: "9710 9810平台服务",
    path: "/btoB/terrace"
}, ]

export const tabList = [{
    label: "9710 9810出口业务介绍",
    key: 0,
}, {
    label: "开展跨境电商B2B出口的优势",
    key: 1,
    isFlex: true
}]
export const flowTabList = [{
    label: "跨境电商B2B出口业务流程",
    key: 0,
}, ]


// WEBPACK FOOTER //
// ./src/model/bToB.js